import React, { useState, useEffect,useRef } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import icon1 from '../Asset/Vector 7.png';
import arrowBottom from '../Asset/Arrow 6.png';

const ProfessionalDoctorFAQ = () => {
  const [faqs] = useState([
    {
      question: "Q1. Is it mandatory for doctors to have Professional Indemnity Insurance?",
      answer: (
        <>
          Although <span style={{ color: "#F37435", fontWeight: "700" }} >not mandatory,</span> investing in professional indemnity insurance for doctors is strongly advised. It offers protection against potential legal liabilities that could arise during your practice.

        </>
      )
    },
    {
      question: "Q2. What is the difference between general liability and professional indemnity insurance?",
      answer: (
        <>
        <span style={{ color: "#F37435", fontWeight: "700" }} >• General liability insurance</span> covers claims arising from injury or property damage caused to third parties due to business operations or premises, like slip-and-fall accidents or property damage. It's important for businesses interacting with the public.
       <br></br> <span style={{ color: "#F37435", fontWeight: "700" }} >• Professional indemnity insurance, </span>on the other hand, protects professionals from claims of negligence or errors in their services that lead to financial loss for clients or patients. It's essential for professionals like doctors covering mistakes in advice or service delivery.
       </>
      )
    },
    {
      question: "Q3. What is professional negligence?",
      answer:(
        <>
        Professional negligence in medical practice refers to <span style={{ color: "#F37435", fontWeight: "700" }} >mistakes, omissions, or unintentional errors</span> by a healthcare provider during diagnosis or treatment. These errors can lead to bodily harm, illness, adversity, or even death for the patient.
      </>
      )
      },

      {
        question: "Q4. Does professional indemnity insurance protect doctors against personal injury claims like defamation or libel?",
        answer:(
          <>
        <span style={{ color: "#F37435", fontWeight: "700" }} >Yes,</span> professional indemnity insurance typically includes coverage for personal injury claims such as defamation or libel. This coverage extends to legal expenses incurred in defending against accusations of harm to a person's reputation or character resulting from professional activities.
        </>
        )
        },
    {
      question: "Q5. What should doctors consider when selecting the best coverage for their professional Indemnity Insurance?",
      answer: (
        <>
         Doctors should consider factors such as the <span style={{ color: "#F37435", fontWeight: "700" }} >nature of their medical practice, specialty, potential risks they face, </span>and the coverage limits provided by insurers. It's essential to ensure the policy meets their specific professional needs and provides adequate protection against potential liabilities
        </>
      )
      
    
    },
    {
      question: "Q6. Does professional indemnity insurance cover legal expenses for non-medical disputes, like employment-related claims?",
      answer: (
        <>
           Professional indemnity insurance typically <span style={{ color: "#F37435", fontWeight: "700" }} >does not cover legal</span> costs for non-medical disputes such as employment-related claims. It specifically protects against claims related to professional negligence or errors in professional services rendered. For employment disputes, separate insurance policies would be needed.
        </>
      )
      
    },
    {
      question: "Q7. When can a claim get rejected?",
      answer: (
      
       <>
        

           <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Non-Disclosure: </span>If the insured doctor failed to disclose relevant information or misrepresented facts when applying for the policy.
        

         <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Exclusions: </span>Claims falling under specific policy exclusions, such as criminal acts, deliberate wrongdoing, or certain types of procedures not covered by the policy.
        

        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Policy Limits:</span> If the claim exceeds the coverage limits specified in the policy.
        

       <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Late Notification: </span>Not informing the insurer immediately after knowing about a possible claim or incident can affect how well the insurer can investigate and handle the claim.
        

      <br></br><span style={{ color: "#F37435", fontWeight: "700" }}> • Breach of Conditions: </span>Non-compliance with policy conditions, such as not cooperating with the insurer during the claims process or failing to meet procedural requirements outlined in the policy.
        

        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Insufficient Evidence: </span>Not having enough proof or documents to support the claim and show the insured's responsibility.
        </>

      )
      
    },
   
   
  ]);

  const [visible, setVisible] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const faqContainerRef = useRef(null);

 const toggleVisibility = () => {
    if (window.pageYOffset > 100 && !buttonClicked) {
      setVisible(true);
    } else if (window.pageYOffset <= 100) {
      setVisible(false);
      setButtonClicked(false); // Allow the button to reappear once the user scrolls back to the top
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault(); // Prevent the default anchor click behavior
    console.log(visible); // Log current state
    setVisible(false); // Hide the button immediately when clicked
    setButtonClicked(true); // Mark the button as clicked
  };

  useEffect(() => {
    if (!visible && buttonClicked) {
      console.log(visible); // Log updated state
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [visible, buttonClicked]);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [buttonClicked]);



  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

//   const handleFaqClick = (index) => {
//     setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
//   };
const handleFaqClick = (index) => {
    if (isMobile) {
      setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
    } else {
      setSelectedFaqIndex(index);
    }
  };
  const handleClickOutside = (event) => {
    if (faqContainerRef.current && !faqContainerRef.current.contains(event.target)) {
      setSelectedFaqIndex(null);
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile]);

  return (
    <div>
      <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div ref={faqContainerRef} className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <img src={icon1} className="side-arrow" alt="sideicon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
            // style={styles.scroll}
            
          >
            <img src={arrowBottom} id="arrowsign" alt="Scroll to top"  />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '5%',
    bottom: '10rem',
    // right: '2%',
    // bottom: '1rem',
    cursor: 'pointer',
    width: '71px',
    height: '71px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
    // boxShadow: '0px 10px 26px rgba(0, 109, 141, 0.2)', 
    boxShadow: '0px 1px 16px rgba(0, 109, 141, 0.25)',
  },
 

  
 span: {
    display: 'block'
  }

};



export default ProfessionalDoctorFAQ;